import React, { useState } from 'react';
import { Box, Typography, Paper, Grid, Tabs, Tab, Divider, Skeleton } from '@mui/material';
import { Person, Security, Email, Badge } from '@mui/icons-material';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import { useTranslation } from 'react-i18next';
import { useGetProfile } from '../../hooks/profile/useGetProfile';
import { useUpdateProfile } from '../../hooks/profile/useUpdateProfile';
import { useUpdatePassword } from '../../hooks/profile/useUpdatePassword';
import FormEditProfile from '../../components/profile/FormEditProfile';
import FormChangePassword from '../../components/profile/FormChangePassword';

const Profile = () => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');
    const { profile, isLoading } = useGetProfile();
    const { updateProfile, isUpdating } = useUpdateProfile();
    const { updatePassword, isUpdating: isChangingPassword } = useUpdatePassword();

    const [tab, setTab] = useState(0);

    const breadcrumbs = [
        { name: isArabic ? 'لوحة التحكم' : 'Dashboard', href: '/dashboard' },
        { name: isArabic ? 'الملف الشخصي' : 'Profile' },
    ];

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };

    if (isLoading) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs links={breadcrumbs} />
                <Grid container spacing={3} sx={{ mt: 3 }}>
                    <Grid item xs={12} md={4}>
                        <Skeleton variant="rectangular" height={300} sx={{ borderRadius: 3 }} />
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Skeleton variant="rectangular" height={500} sx={{ borderRadius: 3 }} />
                    </Grid>
                </Grid>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs links={breadcrumbs} />

            <Grid container spacing={3} sx={{ mt: 3 }}>
                {/* Left Side: Summary Card */}
                <Grid item xs={12} md={4}>
                    <Paper sx={{ p: 4, borderRadius: 3, textAlign: 'center', height: '100%' }}>
                        {/* <Avatar
                            src={profile?.avatar_url}
                            sx={{ width: 100, height: 100, mx: 'auto', mb: 2, border: '3px solid', borderColor: 'primary.main' }}
                        /> */}
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>{profile?.name}</Typography>
                        <Typography variant="body2" color="text.secondary" gutterBottom>{profile?.email}</Typography>

                        <Divider sx={{ my: 3 }} />

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Badge color="action" fontSize="small" />
                                <Typography variant="body2" color="text.secondary">
                                    {isArabic ? 'الدور:' : 'Role:'} <Typography component="span" variant="body2" sx={{ fontWeight: 600, color: 'primary.main' }}>
                                        {profile?.roles?.[0]?.name || 'User'}
                                    </Typography>
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Email color="action" fontSize="small" />
                                <Typography variant="body2" color="text.secondary">
                                    {profile?.email}
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>

                {/* Right Side: Forms Card */}
                <Grid item xs={12} md={8}>
                    <Paper sx={{ borderRadius: 3, overflow: 'hidden' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.neutral' }}>
                            <Tabs value={tab} onChange={handleTabChange} sx={{ px: 2 }}>
                                <Tab
                                    icon={<Person />}
                                    iconPosition="start"
                                    label={isArabic ? 'البيانات الشخصية' : 'Personal Info'}
                                />
                                <Tab
                                    icon={<Security />}
                                    iconPosition="start"
                                    label={isArabic ? 'الأمان' : 'Security'}
                                />
                            </Tabs>
                        </Box>

                        <Box sx={{ p: 4 }}>
                            {tab === 0 && (
                                <FormEditProfile
                                    profile={profile}
                                    onSave={updateProfile}
                                    isSaving={isUpdating}
                                />
                            )}
                            {tab === 1 && (
                                <FormChangePassword
                                    onSave={updatePassword}
                                    isSaving={isChangingPassword}
                                />
                            )}
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </WrapperSection>
    );
};

export default Profile;
